import { Fragment, useState } from "react";
import Paginator from "../../Pagination/Pagination.component";
import ButtonLoader, { Loader } from "./../../../UI/Loaders/Loaders";
import useAllDueRepayment from "../../../custom-hooks/useAllDueRepayment";
import CustomSelectDropdown from "./../../CustomHTMLElements/CustomSelectDropdown";
import useAllAggregators from "../../../custom-hooks/useAllAggregators";
import { connect } from "react-redux";
import { showModal, hideModal } from "../../../redux/actions/modal";
import { setToast } from "../../../redux/actions/toast";
import { postDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { useQueryCache } from "react-query";
import { errorHandler } from "../../../helpers/errorHandler";
import { formatMoney } from "../../../helpers/formatter";
import Alert from "../../../NewComponents/Alert/Alert.component";
import useWalletDetails from "../../../custom-hooks/useWalletDetails";
import { appInsights } from "../../../config/appInsights";
import { BASE_URL } from "../../../appConstants";
import { getTokenFromLocalStorage } from "../../../helpers/localStorage";

const DueLoanRepayment = ({ setToast, showModal, hideModal }) => {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [repayError, setRepayError] = useState(null);
  const [repaySuccess, setRepaySuccess] = useState(null);
  // Component State
  const [state, setState] = useState({
    checkStatus: "off",
    loansForRepayment: [],
    totalAmount: 0,
  });
  const [search, setSearch] = useState({
    PastDue: null,
    MinDateDue: null,
    LoanRef: "",
    size: 20,
    aggregatorId: "",
    pageNumber: 1,
  });
  const { data: aggregatorData } = useAllAggregators();
  const { data, status, error } = useAllDueRepayment(search);
  const { data: walletDetails, status: walletDetailsStatus } = useWalletDetails(
    search.aggregatorId
  );
  if (data) {
    if (count === null) {
      setCount(data.totalCount);
    }
  }

  const queryCache = useQueryCache();
  const resetLoansForRepayment = () => {
    setState({
      ...state,
      loansForRepayment: [],
      totalAmount: 0,
      checkStatus: "off",
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearch({ ...search, [name]: value, pageNumber: 1, size: 20 });
  };
  // Repay Selected Loans
  const repaySelectedLoans = (e) => {
    e.preventDefault();
    const loansForRepayment = state.loansForRepayment;
    if (loansForRepayment.length === 0)
      return setToast("warning", "You have not selected any loans");
    showModal({
      modalIdentifier: "Loan",
      dataId: e.target.dataset["ref"],
      action: "repayapprovedbatchloan",
      subModal: "multiple",
      loans: state.loansForRepayment,
      totalAmount: state.totalAmount,
      repayBatchLoans,
    });
  };

  const repayBatchLoans = async (e) => {
    e.preventDefault();
    setLoading(true);
    setRepayError(null);
    setRepaySuccess(null);

    try {
      const response = await postDataWithDotNet(
        `${ajaxEndpoints.AUTO_REPAY_LOAN}?AggregatorId=${search.aggregatorId}`,
        state.loansForRepayment
      );
      queryCache.invalidateQueries([search, "getAllDueRepayment"]);
      queryCache.invalidateQueries([search.aggregatorId, "getWalletDetails"]);
      setLoading(false);
      setRepaySuccess(response.message);
      hideModal();
      setSearch({ ...search, pageNumber: 1 });
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "DueLoanRepayment.jsx",
        },
      });
      queryCache.invalidateQueries([search, "getAllDueRepayment"]);
      queryCache.invalidateQueries([search.aggregatorId, "getWalletDetails"]);
      setLoading(false);
      setRepayError(errorHandler(error));
      hideModal();
      setSearch({ ...search, pageNumber: 1 });
    }
    setState({
      ...state,
      checkStatus: "off",
      loansForRepayment: [],
      totalAmount: 0,
    });
  };
  // Multiple Checkbox
  const checkAllLoansForRepayment = (e) => {
    e.preventDefault();
    if (e.target.dataset["state"] === "checked") {
      const allLoans = document.querySelectorAll(".loans_for_repayment");
      for (let i = 0; i < allLoans.length; i++) {
        allLoans[i].checked = false;
      }

      e.target.dataset["state"] = "unchecked";

      setState({
        ...state,
        checkStatus: "off",
        totalAmount: 0,
        loansForRepayment: [],
      });

      return;
    }

    let totalAmount = 0;
    let loans = [];
    const allLoans = document.querySelectorAll(".loans_for_repayment");
    for (let i = 0; i < allLoans.length; i++) {
      allLoans[i].checked = true;
      const loan_Id = Number(allLoans[i].dataset["ref"]);
      const amount = Number(allLoans[i].dataset["amounttorepay"]);
      const duedate = Number(allLoans[i].dataset["duedate"]);
      loans.push({ loan_Id, amount, duedate });
      totalAmount += Number(
        JSON.parse(allLoans[i].dataset["record"]).amountToRepay
      );
    }

    e.target.dataset["state"] = "checked";

    setState({
      ...state,
      checkStatus: "on",
      totalAmount,
      loansForRepayment: [...state.loansForRepayment, ...loans],
    });
  };

  const handleDownload = (e) => {
    e.preventDefault();
    setDownloadLoading(true);

    let token = getTokenFromLocalStorage();

    const query = { ...search };

    Object.keys(query).map((item) => {
      if (
        query[item] === null ||
        query[item] === undefined ||
        query[item] === ""
      ) {
        delete query[item];
      }
    });

    fetch(
      BASE_URL +
        `${ajaxEndpoints.DOWNLOAD_ALL_DUE_LOAN_REPAYMENT}?${new URLSearchParams(
          query
        )}`,
      {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: "Token " + token,
        },
      }
    )
      .then((response) => {
        setDownloadLoading(false);
        if (response.status === 200 || response.status === 201) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${`DueLoanRepayments.csv`}`);
            link.click();
          });
        }

        if (response.status === 403 || response.status === 401) {
          localStorage.removeItem("sso_auth_token");
          this.props.history.push("/login");
        }

        if (response.status >= 500) {
          // this.setState({ error: "Something went wrong. Please check your internet connection and try again" });
        }
      })
      .catch(() => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "DueLoanRepayment.jsx (Download)",
          },
        });

        setDownloadLoading(false);
      });
  };

  // Open Modal
  const modalHandler = (
    e,
    tableName,
    modalRow,
    action,
    resetLoansForRepayment,
    subModal
  ) => {
    if (subModal === "single") {
      showModal({
        modalIdentifier: tableName,
        dataRecord: modalRow,
        eventTarget: e.target,
        action: action,
        resetLoansForRepayment,
        repayBatchLoans,
        loading,
        request: modalRow,
      });
    } else {
      showModal({
        modalIdentifier: tableName,
        dataRecord: modalRow,
        eventTarget: e.target,
        action: action,
        request: modalRow,
        repayBatchLoans,
        loading,
      });
    }
  };
  // Single Checkbox
  const checkboxHandler = ({ dataRecord: { amountToRepay }, eventTarget }) => {
    let loans = [];
    const loan_Id = Number(eventTarget.dataset["ref"]);
    const amount = Number(eventTarget.dataset["amounttorepay"]);
    const duedate = Number(eventTarget.dataset["duedate"]);
    loans.push({ loan_Id, amount, duedate });
    if (eventTarget.checked === false) {
      const loansForRepayment = state.loansForRepayment;
      const newLoansForRepayment = loansForRepayment.filter((loan) => {
        return (
          Number(loan.duedate) !== Number(duedate) ||
          Number(loan.loan_Id) !== Number(loan_Id)
        );
      });
      const totalamount = state.totalAmount
        ? Number(state.totalAmount) - Number(amountToRepay)
        : 0;
      return setState(
        {
          ...state,
          loansForRepayment: [...newLoansForRepayment],
          totalAmount: totalamount,
        },
        () => {}
      );
    }

    setState(
      {
        ...state,
        loansForRepayment: [...state.loansForRepayment, ...loans],
        totalAmount: state.totalAmount + Number(amountToRepay),
      },
      () => {}
    );
  };

  let RenderedComponent = null;
  if (!data && !search.aggregatorId && status !== "loading" && !error) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> No aggregator is selected
          </h4>
        </div>
      </div>
    );
  } else if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Due Loans
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = <Loader centered="true" text="Loading Due Loans..." />;
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              due loans, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (data && data.data && data.data.length === 0) ||
      (data && !data.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no requests.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th></th>
                  <th>Loan Id</th>
                  <th>Reference</th>
                  <th>Borrower</th>
                  <th>Product</th>
                  <th>Outstanding Amount</th>
                  <th>Principal Amount</th>
                  <th>Interest</th>
                  <th>Overdue Days</th>
                  <th>Due Date</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((request, id) => {
                  const {
                    loanRef,
                    borrowerName,
                    productName,
                    amountToRepay,
                    dateDue,
                    principal,
                    currency,
                    interest,
                    daysOverdue,
                    loanId,
                  } = request;
                  return (
                    <tr key={id}>
                      <td>
                        <input
                          type="checkbox"
                          data-record={JSON.stringify(request)}
                          data-id={loanId}
                          data-ref={loanId}
                          data-amounttorepay={Number(amountToRepay)}
                          data-duedate={Number(daysOverdue)}
                          defaultChecked={state.loansForRepayment.includes(
                            loanId
                          )}
                          onClick={(e) =>
                            checkboxHandler({
                              dataRecord: request,
                              eventTarget: e.target,
                            })
                          }
                          className={`Loan loans_for_repayment`}
                        />
                      </td>
                      <td>{loanId}</td>
                      <td>{loanRef}</td>
                      <td className="text-uppercase" style={{ width: "10%" }}>
                        {borrowerName}
                      </td>
                      <td className="font-weight-semi-normal">{productName}</td>
                      <td>{formatMoney(amountToRepay, currency)}</td>
                      <td>
                        {principal ? formatMoney(principal, currency) : null}
                      </td>
                      <td>
                        {interest ? formatMoney(interest, currency) : null}
                      </td>
                      <td style={{ minWidth: "120px" }}>{daysOverdue}</td>
                      <td style={{ minWidth: "120px" }}>
                        {dateDue?.substring(0, 10)}
                      </td>
                      <td>
                        <div class="dropdown">
                          <button
                            className="btn zoom-element btn-slim dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          ></button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <span
                              key="0"
                              id="0"
                              data-id={loanId}
                              data-table={"DueLoanRepayment"}
                              data-action="View-Transaction-History"
                              className="Loan cursor-pointer dropdown-item"
                              onClick={(e) => {
                                showModal({
                                  modalIdentifier: "loantransactionhistory",
                                  dataRecord: loanRef,
                                });
                              }}
                            >
                              TRANSACTION HISTORY
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  return (
    <Fragment>
      <div className="dataTables_wrapper">
        {repayError && <Alert message={repayError} />}
        {repaySuccess && <Alert message={repaySuccess} type="success" />}
        <div
          id="activeEcosystem"
          className="Disbursement table-view animated speed-1x fadeInRight"
        >
          <div className="block-header">
            <div className="flex-row m-b-2 m-t-1">
              {walletDetailsStatus === "loading" && search.aggregatorId ? (
                <ButtonLoader />
              ) : (
                <h5 className="page-subtitle">
                  {walletDetails
                    ? `Wallet Balance: 
                  ${
                    walletDetails?.summary?.availableBalance
                      ? formatMoney(
                          walletDetails?.summary?.availableBalance,
                          walletDetails?.summary?.currency?.code
                        )
                      : "N/A"
                  }`
                    : ""}
                </h5>
              )}

              <div className="flex-row m-b-1">
                <div className="m-r-1">
                  <div className="rounded-border flex-row">
                    <div
                      data-state="unchecked"
                      onClick={checkAllLoansForRepayment}
                    >
                      <i
                        className={`adv-icon fas fa-toggle-${state.checkStatus} fa-2x`}
                      />
                    </div>
                    &nbsp; <span>Select all</span>
                  </div>
                </div>
                <div className="m-r-1 rounded-border">
                  Selected: {state?.loansForRepayment?.length}
                </div>

                <div className="rounded-border">
                  Total Amount: {state?.totalAmount?.toFixed(2)}
                </div>
              </div>

              <div className="m-b-1">
                <button
                  id="create"
                  data-id="create-role"
                  data-action="create"
                  className="create zoom-element btn advancly-btn"
                  onClick={(e) => {
                    modalHandler(
                      e,
                      "Loan",
                      state,
                      "loanrepayment",
                      resetLoansForRepayment,
                      repaySelectedLoans
                    );
                  }}
                  disabled={!state.loansForRepayment?.length}
                >
                  <i className="far fa-credit-card" /> Repay Loan
                  {loading && <ButtonLoader />}
                </button>
                <button
                  id="create"
                  className="create zoom-element btn advancly-btn ml-2"
                  onClick={handleDownload}
                >
                  <i className="fas fa-download m-r-1" /> Download
                  {downloadLoading && <ButtonLoader />}
                </button>
              </div>
            </div>
            <form className="d-flex flex-row flex-wrap">
              <div style={{ marginBottom: "30px" }}>
                <CustomSelectDropdown
                  onChange={(e) => handleChange(e)}
                  name="aggregatorId"
                  value={search.aggregatorId}
                  className="round user__form form-control"
                >
                  <option value="">search by aggregator</option>
                  {aggregatorData &&
                    aggregatorData.map((aggregator) => {
                      const { biz_name, aggregator_id } = aggregator;
                      return (
                        <option
                          value={Number(aggregator_id)}
                          key={aggregator_id}
                        >
                          {biz_name}
                        </option>
                      );
                    })}
                </CustomSelectDropdown>
              </div>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="round user__form form-control"
                  placeholder="Loan Ref"
                  name="LoanRef"
                  onChange={(e) => handleChange(e)}
                  value={search.LoanRef}
                />
              </div>
              <div className="form-group inputWithIcon">
                <input
                  type="number"
                  placeholder="Due Days"
                  className="round user__form form-control"
                  name="PastDue"
                  value={search.PastDue}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="form-group mb-4">
                <div className="input-group">
                  {/* <label className="mr-2">Min Date: </label> */}
                  <input
                    type="date"
                    className="round user__form form-control"
                    name="MinDateDue"
                    value={search.MinDateDue}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
            </form>
          </div>

          {/*Datatable || Loader || Error Message*/}
          <div className="d-flex flex-row flex-wrap justify-content-start m-l-1 m-t-1">
            <label htmlFor="table-fetch" className="form-group">
              Number of results:{" "}
              <select
                onChange={(e) => {
                  setSearch({ ...search, size: e.target.value, pageNumber: 1 });
                }}
                id="table-fetch"
                className="table-fetch-select m-l-1"
                value={search.size}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={100}>150</option>
                <option value={100}>200</option>
              </select>
            </label>
          </div>

          {RenderedComponent}
          <Paginator
            size={search.size}
            page={search.pageNumber}
            count={count}
            changeCurrentPage={(pageNumber) =>
              setSearch({ ...search, pageNumber })
            }
          />
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = () => {
  return {};
};
export default connect(mapStateToProps, {
  showModal,
  hideModal,
  setToast,
})(DueLoanRepayment);
